var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornerSquareArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1170.000000, -595.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.000000, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.691 -1.56319402e-13 119.192 0.599 118.592 1.4 111.992 9.8 118.592 9.8 119 9.8 119 120.686 -1.27897692e-12 120.686 -1.27897692e-12 121.686 119 121.686 120 121.686 120 120.686 120 9.8 120.391 9.8 127.291 9.8 119.692 -1.56319402e-13"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerSquareArrowRight);
export default __webpack_public_path__ + "static/media/corner-square-arrow-right.6425404e2ea87e0903cdb2dea6320875.svg";
export { ForwardRef as ReactComponent };